import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=ff453ca2&lang=pug"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports